<template>
  <n-dropdown :options="options" placement="bottom-end" @select="handleSelect">
    <n-avatar ref="headerbaravatar" round :size="32" v-bind:src="imagePath" fallback-src="/images/avatar-64.png"/>
  </n-dropdown>
</template>

<script lang="ts" setup>
import {NAvatar, NDropdown} from "naive-ui"
import {Logger, renderIcon} from "@/utils"
import {useRouter} from "vue-router"
import {computed, h, ref} from "vue"
import {useAuthStore} from "@/stores/auth"
import {useNotificationsStore} from "@/stores/useNotificationsStore"

const UserIcon = "ion:person-outline"
const LogoutIcon = "ion:log-out-outline"
const DocsIcon = "ion:book-outline"
const CalendarIcon = "carbon:calendar"
const BuyIcon = "carbon:shopping-cart"
const router = useRouter()
const authStore = useAuthStore()
const notificationsStore = useNotificationsStore()
const isSubsMissing = computed(() => authStore.getSubscriptionIsRequired() || authStore.getAccountRolePlayerFree())
const options = ref([
  {
    label: "Profile",
    key: "route-Profile",
    icon: renderIcon(UserIcon)
  },
  // {
  // 	label: "Game days",
  // 	key: "route-Calendar",
  // 	icon: renderIcon(CalendarIcon)
  // },
  {
    label: () =>
        h(
            "a",
            authStore.getUpgradeButtonLabel()
        ),
    key: "buy-now",
    icon: renderIcon(BuyIcon),
    show: isSubsMissing
  },
  {
    label: "Logout",
    key: "logout",
    icon: renderIcon(LogoutIcon)
  }
])

const accountInfo = authStore.account

const imagePath = computed(() => {
  return typeof accountInfo.imagePath === 'string' ? accountInfo.imagePath : '/images/avatar.png';
});

function handleSelect(key: string) {
  if (key.indexOf("route-") === 0) {
    const path = key.split("route-")[1]
    router.push({name: path})
  }
  if (key === "buy-now") {
    goToShop()
  }
  if (key === "logout") {
    handleLogout()
  }
}

async function goToShop() {
  if (!authStore.getSubscriptionIsRequired() && !authStore.getAccountRolePlayerFree()) return

  let missingSubs = authStore.getMissingSubscriptions()[0]?.[0]
  if (authStore.getAccountRolePlayerFree()) {
    missingSubs = "ROLE_PLAYER_PRO"
  }

  if (!missingSubs) return

  const paymentUrl = await authStore.fetchPaymentUrl(missingSubs)
  if (!paymentUrl || paymentUrl.length < 4) return

  window.open(paymentUrl, "_blank")
}

function handleLogout() {
  try {
    Logger.debug('Starting logout process...')
    notificationsStore.closeMercureSubscription().then(() => {
      notificationsStore.unsubscribeWebPushSubscription().then(() => {
        notificationsStore.updateAppPushNotificationSignOut().then(() => {
          authStore.setLogout()
          setTimeout(() => {
            Logger.debug('Logout completed, navigating to login')
            window.location.href = '/login'
          }, 100)
        })
      })
    })

    router.push({name: 'Login'})

  } catch (error) {
    Logger.error('Error during logout:', error)
    // Even if cleanup fails, still logout
    authStore.setLogout()
    window.location.href = '/login'
  }
}
</script>
